/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../../../common/Form';
import { form as FormStyle } from '../../../style/form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import ErrorInline from '../../../common/ErrorMessages/ErrorInline';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => FormStyle(typography, palette);

class DesktopChangeEmail extends Form {
    state = {
        data: {
            currentemail: '',
            newemail: '',
        },
        errors: {},
    };

    schema = {
        currentemail: Joi.string()
            .trim()
            .required()
            .label('Current Email'),
        newemail: Joi.string()
            .trim()
            .invalid(Joi.ref('currentemail'))
            .email({ minDomainAtoms: 2 })
            // .email({ minDomainSegments: 2 })
            // .email()
            .required()
            .label('New Email'),
        confirmnewemail: Joi.any(),
        template: Joi.any(),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        this.props.fetchEmailAddress();
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { data, errors } = this.state;
        if (props.buttonType === 'SubmitProfile' && data.newemail) {
            if (this.validate(true)) {
                this.doSubmit();
            } else {
                const { newemail } = this.validate();
                if (newemail) {
                    errors.newemail = newemail;
                }
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (props.newEmail) {
                data.newemail = '';
                data.currentemail = props.newEmail;
            } else if (props.email) {
                data.currentemail = props.email;
            }
            this.setState({ data });
        }
    };

    doSubmit = () => {
        const { handleChangeNewEmailAddress } = this.props;
        const { data } = this.state;
        if (data.newemail) {
            data.confirmnewemail = data.newemail;
            data.template = 'desktop';
            handleChangeNewEmailAddress(data);
        }
    };

    handleNewEmailChange = (dataChanged) => {
        const data = { ...dataChanged };
        let { errors } = this.state;
        if (data.newemail === data.currentemail) {
            errors = {
                newemail: 'Please enter new Email.',
            };
            this.setState({ errors });
        } else {
            delete errors.newemail;
            this.setState({ errors });
        }
    };

    updatedEmailTempate = () => (
        <>
            <p data-test="my-account-success-email-changed">
                <span className="bold">Congratulations!</span> You have updated
                your email.
            </p>
        </>
    );

    changeEmailForm = (props) => {
        const { classes, isReadyState } = props;
        return (
            <>
                <form
                    onSubmit={(event) => this.handleSubmit(event, {})}
                    className={`${classes.form} margin-bottom-2x`}
                    disabled={!isReadyState}
                >
                    <div className="split position-relative">
                        {this.renderInput({
                            name: 'currentemail',
                            label: 'Current Email *',
                            dataTest: { field: 'my-account-new-email' },
                            type: 'email',
                            desktop: true,
                            disabled: true,
                            length: 50,
                        })}
                        <div>
                            <span className="small gray-color position-absolute-bottom">Used as Login ID</span>
                        </div>
                        <div />
                    </div>
                    <div className="margin-top-2x">
                        <p className="no-margin">To change your Email, enter it below:</p>
                        <div className="split position-relative">
                            <div>
                                {this.renderInput({
                                    name: 'newemail',
                                    label: '',
                                    placeholder: '- New Email -',
                                    dataTest: { field: 'my-account-new-email' },
                                    type: 'email',
                                    desktop: true,
                                    length: 50,
                                    onChangeHandler: this.handleNewEmailChange,
                                })}
                                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                                <ErrorInline {...props} name="updateNewEmailAddress" customClass="small" />
                            </div>
                            <div />
                            <div />
                        </div>
                    </div>
                    <div className="display-none">
                        {this.renderButton({
                            label: isReadyState ? 'Update Email' : 'Updating Email...',
                            className: 'buttonHD',
                            dataTest: { field: 'my-account-update-email' },
                            onClick: null,
                            type: 'submit',
                            isValidated: true,
                            isReadyState,
                        })}
                    </div>
                </form>
            </>
        );
    };

    handleContinueShoppingClicked = () => {
        this.props.history.push('/');
    };

    render() {
        const {
            newEmail,
        } = this.props;
        return (
            <>
                {newEmail ? this.updatedEmailTempate() : ''}
                {this.changeEmailForm(this.props)}
            </>
        );
    }
}

DesktopChangeEmail.defaultProps = {
    email: '',
    buttonType: '',
};

DesktopChangeEmail.propTypes = {
    classes: object.isRequired,
    email: string,
    buttonType: string,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('ChangeEmail - newState', newState);
    return {
        isReadyState: newState.isReadyState,
        email: newState.email,
        newEmail: newState.newEmail,
        buttonType: newState.buttonType,
        toggleState: newState.toggleState,
        error: newState.error,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchEmailAddress: () => dispatch(EventDispatcher.fetchEmailAddress()),
    handleChangeNewEmailAddress: (data) => dispatch(EventDispatcher.handleChangeNewEmailAddress(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopChangeEmail)));
